import { getValue } from "@clockwise/client-commons/src/util/errorable.util";
import { PlannerMetadataOrg } from "../types";

export const parseColorSettingsGQL = (org?: PlannerMetadataOrg) => {
  return getValue(org?.eventColoringSettingsErrorable) || undefined;
};
